import * as Messages from "../../../../Messages";
import { toolEmail } from "../../../../settings";
import * as React from "react";
import { JobInfoContext } from "../../../../job-info-context";
import { useContext } from "react";
import { EmailLink } from "@loschmidt/commons";

export function CheckedSpinner({withText, errTextBefore}: {withText: boolean, errTextBefore?: string }) {
  
  const {jobInfo} = useContext(JobInfoContext);

  const finished = jobInfo && [5, -1].includes(jobInfo.status);
  
  if (!finished) {
    if (withText) {
      return <>
        {Messages.spinnerIcon}
        <span>This calculation is still on-going.</span>
      </>
    } else {
      return Messages.spinnerIcon;
    }
  } else {
    if (withText) {
      return <>
        {Messages.warnIcon}
        <span>
          {errTextBefore ? errTextBefore + ' ' : ''}
          This calculation failed. Please report this issue to <EmailLink email={toolEmail}/>.
        </span>
      </>
    } else {
      const title = (errTextBefore ? errTextBefore + ' ' : '') + `This calculation failed. Please report this issue to ${toolEmail}.`;
      return <span title={title}>
        {Messages.warnIcon}
      </span>
    }
  }
}